import { SHOPIFY_SCOPES } from '@superfunnel/schemas/shopify';
import { SLACK_BOT_SCOPES } from '@superfunnel/schemas/slack';

export const DEFAULT_GOOGLE_ADS_SCOPES = [
  'openid',
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile',
  'https://www.googleapis.com/auth/adwords',
];

export const getGoogleUrl = (from: string, reqId: string, scopes: string[]) => {
  const rootUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

  const options = {
    redirect_uri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID as string,
    access_type: 'offline',
    response_type: 'code',
    prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

export const getFacebookUrl = (
  from: string,
  reqId: string,
  scopes: string[],
) => {
  const rootUrl = 'https://www.facebook.com/v16.0/dialog/oauth';

  const options = {
    redirect_uri: import.meta.env.VITE_FACEBOOK_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_FACEBOOK_OAUTH_APP_ID as string,
    access_type: 'offline',
    response_type: 'code',
    // prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

// HubSpot OAuth

export const HUBSPOT_REQUIRED_SCOPES = [
  'oauth',
  'crm.objects.contacts.write',
  'crm.schemas.contacts.read',
];

// export const HUBSPOT_OPTIONAL_SCOPES = [
//   'crm.objects.contacts.read',
//   'crm.objects.companies.read',
//   'crm.objects.companies.write',
//   'crm.schemas.companies.read',
//   'crm.objects.deals.read',
//   'crm.objects.deals.write',
//   'crm.schemas.deals.read',
//   'crm.lists.read',
//   'crm.lists.write',
// ];

export const getHubSpotUrl = (reqId: string) => {
  const rootUrl = 'https://app.hubspot.com/oauth/authorize';
  const redirectUri = import.meta.env.VITE_HUBSPOT_OAUTH_REDIRECT_URI as string;
  const clientId = import.meta.env.VITE_HUBSPOT_CLIENT_ID as string;

  const options = {
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: HUBSPOT_REQUIRED_SCOPES.join(' '),
    // optional_scope: HUBSPOT_OPTIONAL_SCOPES.join(' '),
    state: reqId,
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

// Shopify OAuth (SuperFunnel Shopify app)

/** Shared with the backend via @superfunnel/schemas. */
export { SHOPIFY_SCOPES };

/**
 * Shopify's authorize endpoint lives on the merchant's own domain, so the store
 * has to be known before the flow can start -- unlike every other provider here.
 */
export const getShopifyUrl = (reqId: string, shopDomain: string) => {
  const redirectUri = import.meta.env.VITE_SHOPIFY_OAUTH_REDIRECT_URI as string;
  const clientId = import.meta.env.VITE_SHOPIFY_API_KEY as string;

  const options = {
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: SHOPIFY_SCOPES.join(','),
    state: reqId,
  };

  const qs = new URLSearchParams(options);

  return `https://${shopDomain}/admin/oauth/authorize?${qs.toString()}`;
};

// Slack OAuth (SuperFunnel Slack bot app)

/** Shared with the backend via @superfunnel/schemas. */
export { SLACK_BOT_SCOPES };

export const getSlackUrl = (reqId: string) => {
  const rootUrl = 'https://slack.com/oauth/v2/authorize';
  const redirectUri = import.meta.env.VITE_SLACK_OAUTH_REDIRECT_URI as string;
  const clientId = import.meta.env.VITE_SLACK_APP_CLIENT_ID as string;

  const options = {
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: SLACK_BOT_SCOPES.join(','),
    state: reqId,
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

export const getTikTokUrl = (from: string, reqId: string) => {
  const query = new URLSearchParams({
    app_id: import.meta.env.VITE_TIKTOK_OAUTH_APP_ID as string,
    redirect_uri: import.meta.env.VITE_TIKTOK_OAUTH_REDIRECT_URI as string,
    state: JSON.stringify({ from, id: reqId }),
  });
  return `https://business-api.tiktok.com/portal/auth?${query}`;
};
